import React from "react";
import Icon from "../../components/icon/Icon";

const Toggle = ({ className, click, icon, style }) => {
  return (
    <a
      href="#toggle"
      className={className ? className : ""}
      style={style}
      onClick={(ev) => {
        ev.preventDefault();
        click(ev);
      }}
    >
      <Icon name={icon} style={style} />
    </a>
  );
};
export default Toggle;
